"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadS3All = exports.uploadS3 = void 0;
var aws_amplify_1 = require("aws-amplify");
var logger_1 = require("../logger");
var logger = logger_1.logger.loggerIn('@sendpayments/js-utils/s3-manager');
var storageTypes = {
    PRIVATE: 'private',
};
var uploadS3 = function (_a, _b) {
    var name = _a.name, content = _a.content, type = _a.type;
    var _c = _b === void 0 ? { level: storageTypes.PRIVATE } : _b, _d = _c.level, level = _d === void 0 ? storageTypes.PRIVATE : _d, identityId = _c.identityId, _e = _c.onProgress, onProgress = _e === void 0 ? function () { } : _e;
    return __awaiter(void 0, void 0, void 0, function () {
        var groupLogger, lastProgress_1, params, key, url, path, ex_1;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    groupLogger = logger.groupIn('upload');
                    if (!name || !content || !type) {
                        throw Error('invalid function input');
                    }
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 4, , 5]);
                    groupLogger.log('starting uploading file', { name: name, content: content, type: type });
                    lastProgress_1 = 0;
                    params = {
                        progressCallback: function (_a) {
                            var loaded = _a.loaded, total = _a.total;
                            var percentage = Math.round((loaded / total) * 100);
                            groupLogger.log("Progress in file ".concat(name, " is ").concat(percentage));
                            onProgress({ percentage: percentage, step: percentage - lastProgress_1 });
                            lastProgress_1 = percentage;
                        },
                        level: level,
                        contentType: type,
                    };
                    if (identityId) {
                        params.identityId = identityId;
                    }
                    return [4 /*yield*/, aws_amplify_1.Storage.put(name, content, params)];
                case 2:
                    key = (_f.sent()).key;
                    groupLogger.log("finished uploading ".concat(name, " to S3"));
                    groupLogger.log("getting S3 url for ".concat(name));
                    // this is just in case we have upload that do now show the 100 upload
                    onProgress({ percentage: 100, step: 0 });
                    return [4 /*yield*/, aws_amplify_1.Storage.get(key, {
                            level: level,
                            identityId: identityId,
                        })];
                case 3:
                    url = _f.sent();
                    groupLogger.log("S3 url for ".concat(name, " is ").concat(url));
                    path = new URL(url).pathname;
                    return [2 /*return*/, {
                            preSignedUrl: url,
                            path: path,
                            key: key,
                        }];
                case 4:
                    ex_1 = _f.sent();
                    onProgress({ percentage: 100 });
                    groupLogger.error("error uploading ".concat(name, " to S3"), ex_1);
                    return [2 /*return*/, { withError: ex_1 }];
                case 5: return [2 /*return*/];
            }
        });
    });
};
exports.uploadS3 = uploadS3;
var uploadS3All = function (fileConfigs, _a) {
    var _b = _a === void 0 ? { level: storageTypes.PRIVATE } : _a, _c = _b.level, level = _c === void 0 ? storageTypes.PRIVATE : _c, identityId = _b.identityId, _d = _b.onProgress, onProgress = _d === void 0 ? function () { } : _d;
    return __awaiter(void 0, void 0, void 0, function () {
        var groupLogger, totalActionPercentage, runningTotalPercentage, onProgressHandler, result;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    groupLogger = logger.groupIn('upload');
                    totalActionPercentage = fileConfigs.length * 100;
                    runningTotalPercentage = 0;
                    groupLogger.log('starting uploading files', fileConfigs);
                    onProgressHandler = function (_a) {
                        var step = _a.step;
                        runningTotalPercentage += step;
                        groupLogger.log("Progress action is ".concat(runningTotalPercentage));
                        onProgress({ percentage: (runningTotalPercentage * 100) / totalActionPercentage });
                    };
                    return [4 /*yield*/, Promise.allSettled(fileConfigs.map(function (file) { return (0, exports.uploadS3)(file, { level: level, identityId: identityId, onProgress: onProgressHandler }); }))];
                case 1:
                    result = _e.sent();
                    // this is just in case we have upload that do now show the 100 upload
                    onProgress({ percentage: 100 });
                    return [2 /*return*/, result.map(function (_a) {
                            var value = _a.value;
                            return value;
                        })];
            }
        });
    });
};
exports.uploadS3All = uploadS3All;
//# sourceMappingURL=index.js.map